import type { RefObject } from "react"
import { useEffect, useRef, useState } from "react"

export const useInView = (element: RefObject<HTMLDivElement | null>, rootMargin?: string, threshold?: number, minimumViewTime?: number) => {
  const [isVisible, setState] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (!element.current) {
      return
    }

    const el = element.current

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry === undefined) return

        if (entry.isIntersecting) {
          if (minimumViewTime && minimumViewTime > 0) {
            timeoutRef.current = setTimeout(() => {
              setState(true)
            }, minimumViewTime)
          } else {
            setState(true)
          }
        } else {
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = null
          }
          setState(false)
        }
      },
      { rootMargin, threshold }
    )

    observer.observe(el)

    return () => {
      observer.unobserve(el)
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [element, rootMargin, threshold, minimumViewTime])

  return isVisible
}
